module.exports = __webpack_public_path__ + "static/img/slider.e6e2785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider.png
// module id = xlXo
// module chunks = 1